import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { SnackBarService } from '@shared/snack-bar/services/snack-bar.service';
import { ModuleLoadingErrorDialogComponent } from '@root/app/module-loading-error-dialog/module-loading-error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ErrorAggregatorService } from '../../error-aggregation/error-aggregator.service';
import { HttpErrorMessageHandlerService } from '@core/error/http-error-message-handler.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  private snackBarService = inject(SnackBarService);
  private readonly dialog = inject(MatDialog);
  private injector = inject(Injector);

  private readonly httpErrorMessageHandlerService = inject(
    HttpErrorMessageHandlerService
  );
  handleError(error: Error | HttpErrorResponse) {
    const errorAggregatorService = this.injector.get(ErrorAggregatorService);

    if (
      (error instanceof HttpErrorResponse &&
        error.error instanceof ProgressEvent) ||
      !navigator.onLine
    ) {
      return;
    }
    if (error instanceof HttpErrorResponse) {
      if (error.url?.includes('AttachedFiles')) {
        return;
      }

      this.httpErrorMessageHandlerService.handleFallbackError(error);
    } else if (
      error instanceof Error &&
      error.message.indexOf('Failed to fetch dynamically imported module') > -1
    ) {
      errorAggregatorService.addModuleError(error);
      this.dialog.open(ModuleLoadingErrorDialogComponent, {
        width: '350px',
      });
    } else {
      // Client Error
      console.error(error);
      const errorMessage = !!error.message ? error.message : error.toString();
      //ignore expression error in dev mode
      if (
        !error.message.includes('ExpressionChangedAfterItHasBeenCheckedError')
      ) {
        errorAggregatorService.addConsole(error);
        this.snackBarService.error(['Frontend Error', errorMessage]);
      }
    }
  }
}
